import { OrgView } from "../components/Org";
import { OrgAgentInvocationPanel, OrgServiceAccountSection } from "../components/OrgAgent";
import { useAgenticPlatformEnabled } from "../../agent-catalog";
import { useOrgParams, usePermissions } from "../hooks";
import { UnauthorizedMessage } from "../../shared/components";

export function OrgAgentsScreen() {
  const { id, category } = useOrgParams();
  const { canViewOrg } = usePermissions();
  const agenticPlatformEnabled = useAgenticPlatformEnabled();

  if (!agenticPlatformEnabled) {
    return <UnauthorizedMessage />;
  }

  if (!canViewOrg(id, category)) {
    return <UnauthorizedMessage />;
  }

  return (
    <OrgView title="Agents">
      {() => (
        <>
          <OrgServiceAccountSection />
          <OrgAgentInvocationPanel />
        </>
      )}
    </OrgView>
  );
}
